import { render, staticRenderFns } from "./TravelGurcustanContainer.vue?vue&type=template&id=12bfd791"
import script from "./TravelGurcustanContainer.vue?vue&type=script&lang=ts"
export * from "./TravelGurcustanContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports